export default {
    props: {
        customerId: {
            required: false,
            default: ''
        },
        timeType: {
            required: true,
        },
        service: {
            type: Function,
            required: false
        }
    },
    created() {
        this.query()
    },
    data() {
        return {
            trendQueryCondition: {
                serviceId: '',
                websiteType: undefined,
            },
            chartConf: {
                config: {
                    labelMap: {
                        submitDate: '时间',
                        num: '询盘数量'
                    }
                },

                data: {
                    columns: ['submitDate', 'num'],
                    rows: []
                }
            }
        }
    },
    watch: {
        customerId() {
            this.query()
        },
        timeType() {
            this.query()
        }
    },
    methods: {
        getCommon() {
            return {
                customerId: this.customerId,
                timeType: this.timeType
            }
        },
        getQuery() {
            return {
                ...this.getCommon(),
                ...this.trendQueryCondition
            }
        },
        async query() {
            this.loading = true
            let data = await this.service(this.getCommon())
            this.chartConf.data.rows = data.data
            this.loading = false
        },
    }
}
